import set from 'lodash/fp/set';
import get from 'lodash/get';
import omit from 'lodash/omit';

import {
  ADD_BASKET_RESPONSE,
  UNDONATE_BASKET_RESPONSE,
  DONATE_BASKET_RESPONSE,
} from 'actions/baskets';
import { EMPTY_OBJECT } from 'lib/constants';
import {
  ADD_MEAL_V3,
  REMOVE_MEAL_V3,
  SET_BASKET_SERVINGS_V3,
  SET_EDITED_BASKET_V3,
  UNDO_BASKET_EDITS_V3,
  CLEAR_EDITED_BASKET_V3,
  UPDATE_MEAL_SERVINGS_V3,
  ADD_SERVINGS_V3,
  REMOVE_SERVINGS_V3,
  UPDATE_BASKET_V3_RESPONSE,
} from 'lib/constants/v3Actions';

const updateBasket = ({ meals }) => {
  if (!meals || meals.length === 0) return EMPTY_OBJECT;

  return meals.reduce(
    (hash, meal) => ({
      ...hash,
      [meal.id]: meal.servings,
    }),
    {}
  );
};

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_BASKET_RESPONSE:
    case UNDONATE_BASKET_RESPONSE:
    case UPDATE_BASKET_V3_RESPONSE:
    case DONATE_BASKET_RESPONSE:
      return updateBasket(action.response.weeklyBasket);
    case UNDO_BASKET_EDITS_V3:
    case SET_EDITED_BASKET_V3:
      return updateBasket(action.basket);
    case ADD_MEAL_V3:
      return set(action.mealId, action.startServings, state);
    case REMOVE_MEAL_V3:
      return omit(state, action.mealId);
    case ADD_SERVINGS_V3: {
      const nextServings = get(state, action.mealId, 0) + action.mealServings;
      return set(action.mealId, nextServings, state);
    }
    case REMOVE_SERVINGS_V3: {
      const nextServings = get(state, action.mealId, 0) - action.mealServings;
      return nextServings > 0
        ? set(action.mealId, nextServings, state)
        : omit(state, action.mealId);
    }
    case SET_BASKET_SERVINGS_V3:
      return action.mealServings;
    case CLEAR_EDITED_BASKET_V3:
      return initialState;
    case UPDATE_MEAL_SERVINGS_V3:
      return set(action.mealId, action.mealServings, state);
    default:
      return state;
  }
};
